var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1988_404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1049 0.0541273C15.5867 -0.22987 10.3253 0.54098 7.01714 4.06389C4.07074 7.20139 3.80109 11.8197 4.8468 15.8498C5.63602 18.8994 7.10922 21.6988 8.83233 24.2953C9.81885 25.7761 12.1865 24.3629 11.1868 22.8821C8.75999 19.2983 6.39235 14.8964 6.59623 10.3862C6.75407 6.80244 9.01648 4.0977 12.0944 2.63039C14.5344 1.46059 17.4545 1.08869 20.1115 0.899357C20.6311 0.865547 20.6377 0.0946983 20.1115 0.067651L20.1049 0.0541273Z",
    fill: "#001B66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.598201 21.0699C1.2493 21.7867 1.97933 22.3411 2.78169 22.8686C3.58406 23.396 4.33381 23.9572 5.14934 24.4373C6.84615 25.4313 8.63503 26.2157 10.4502 26.9324C11.0092 27.1556 11.7195 26.7837 12.0089 26.2833C12.8771 24.7483 13.6071 23.112 14.3437 21.5027C14.712 20.698 15.0869 19.8866 15.442 19.0752C15.8432 18.1691 16.2378 17.2765 16.1654 16.2622C16.126 15.6942 15.5078 15.1871 14.975 15.559C13.515 16.5868 12.8771 18.5883 12.0944 20.1503C11.3118 21.7123 10.4305 23.2743 9.62155 24.8498L11.1802 24.2006C9.45055 23.5988 7.74059 22.9294 6.02405 22.287C5.19537 21.976 4.34697 21.7326 3.53145 21.3809C2.66989 21.0158 1.84121 20.6845 0.933617 20.4681C0.591624 20.387 0.348283 20.7994 0.591624 21.0699H0.598201Z",
    fill: "#001B66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1988_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 27,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountArrow);
export default __webpack_public_path__ + "static/media/discount_arrow.c9b087b675994fb5f1eff8e538c23a2d.svg";
export { ForwardRef as ReactComponent };